import { Inbox } from "lucide-react";
import { motion } from "framer-motion";

export const MessagesLoading = () => {
  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 100 }
    }
  };

  return (
    <motion.div variants={itemVariants} className="text-center py-10">
      <Inbox className="mx-auto h-12 w-12 text-muted-foreground animate-bounce" />
      <p className="mt-2 text-muted-foreground">Loading Conversations...</p>
    </motion.div>
  );
};
